import { bindable } from "aurelia-templating";
import "./axxess-intelligence-border.scss";
import { bindingMode } from "aurelia-binding";

export class AxxessIntelligenceBorder {
    @bindable({ defaultBindingMode: bindingMode.toView })
    public showLogo: boolean = false;
    @bindable({ defaultBindingMode: bindingMode.toView })
    public isFooter: boolean = false;
}
